import { operationsEmail } from "./generic.constant";

export enum QuoteStage {
  PRISE_DE_CONTACT = "674210002",
  ORGANISATION_VT = "694626784",
  EN_ATTENTE_VT = "710645179",
  RECUPERATION_DU_DEVIS = "674210003",
  STAND_BY = "711701993",
  CREATION_ET_ENVOI_DE_LA_PH = "695282417",
  YOUSIGN_VALIDATION = "1518301417",
  CHECK_CONFORMITY = "1252349143",
  EN_ATTENTE_DE_SIGNATURE = "712508645",
  ATTENTE_COACH_COPRO = "1142188256", // Phase entre "attente de signature" et "devis signé" c'est le moment où un devis est accepté parle client mais pas encore signé car il doit d'abord être validé côté Coach copro
  DEVIS_SIGNE = "702310850",
  FERME_PERDU = "712519380",
  REJET_PRO = "1135917303",
  ARCHIVE = "698849526",
}

export const QUOTE_STAGES = Object.values(QuoteStage) as [
  QuoteStage,
  ...QuoteStage[],
];

export const QUOTE_STAGES_ALLOWED_FOR_CLIENT = [
  QuoteStage.EN_ATTENTE_DE_SIGNATURE,
  QuoteStage.ATTENTE_COACH_COPRO,
  QuoteStage.DEVIS_SIGNE,
  QuoteStage.FERME_PERDU,
] as const;

export type QuoteStageAllowedForClient =
  (typeof QUOTE_STAGES_ALLOWED_FOR_CLIENT)[number];

export const QUOTE_STAGES_ALLOWED_FOR_PRO = [
  ...QUOTE_STAGES_ALLOWED_FOR_CLIENT,
  QuoteStage.YOUSIGN_VALIDATION,
  QuoteStage.CHECK_CONFORMITY,
] as const;

export type QuoteStageAllowedForPro =
  (typeof QUOTE_STAGES_ALLOWED_FOR_PRO)[number];

export enum QuoteRejectReason {
  INSUFFICIENT_BUDGET = "Budget insuffisant",
  BETTER_PRICE_ELSEWHERE = "J'ai trouvé un meilleur tarif ailleurs",
  PROJECT_CANCELLED = "Le projet est annulé",
  LATE_RESPONSE = "Réponse tardive du prestataire",
  OTHER_QUOTE_ACCEPTED = "J'ai accepté un autre devis",
}

export const QUOTE_REJECT_REASONS = Object.values(QuoteRejectReason);

export enum QuoteErrorMessage {
  NO_SIGNATORY_FOUND = `Aucun signataire trouvé pour ce devis. Merci de contacter le support. ${operationsEmail}`,
}

export const IMPORTED_SIGNED_QUOTE_PREFIX = "[Import_Client] ";
